import { accountAPI } from "services";
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const defaultValues = {
  name: "",
  phone: "",
  address: "",
  details: "",
  photo: { url: null, loading: false, file: null },
  tag: null
};


const validatePhone = (value) => {
  if (!value) return true; // Phone is optional
  try {
    const isValid = phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
    return isValid || "Please enter a valid phone number";
  } catch (error) {
    return "Invalid phone number format";
  }
};

const validateAccountName = async (value, accountId = null) => {
  if (!value) return "Name is required";
  
  if (accountId) {
    // For EditAccount - check if name changed
    const currentAccount = await accountAPI.getAccountById(accountId);
    if (currentAccount?.get("name") === value) return true;
  }
  
  // Check if name exists
  const accountByName = await accountAPI.getAccountByName(value);
  return !accountByName || "Account with this name already exists";
};

export const formFields = [
  {
    name: 'name',
    type: 'text',
    placeholder: 'Account Name',
    rules: {
      required: "Name is required",
      maxLength: {
        value: 50,
        message: "Name cannot exceed 50 characters"
      },
      validate: validateAccountName
    }
  },
  {
    name: 'phone',
    type: 'phone',
    placeholder: 'Phone no.',
    rules: {
      validate: validatePhone
    }
  },
  {
    name: "tag",
    type: "text",
    placeholder: "Select or create a Tag",
    rules: {
      maxLength : {
        value : 20,
        message : "Tag cannot exceed 20 characters"
      }
    }
  },
  {
    name: 'address',
    type: 'text',
    placeholder: 'Address'
  },
  {
    name: 'details',
    type: 'textarea',
    placeholder: 'Other Details'
  }
];